export const group = {
  modal: {
    remove: {
      content: `Anda yakin ingin menghapus kelompok <b>{name}<b>?`
    },
    add_contact_method: {
      description: `
            Anda dapat membuat metode kontak baru di bagian ini <a href="/pbx/operators/contacts" target="_blank">Contacts</a>
          `
    },
    add_time: {
      description: `
            Anda dapat membuat baru di bagian ini <a href="/pbx/time-conditions" target="_blank">Schedules</a>, after which they are available for selection.
          `
    }
  },

  form: {
    title: {
      edit: 'Nama Kelompok'
    },

    field: {
      name: 'Nama',
      work_time: 'Jadwal waktu kerja'
    },

    button: {
      add_time: 'Pilih Jadwal waktu ',
      add_contact_method: 'Pilih metode kontak'
    }
  }
};
